import { usePensionNameValue } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { Center } from "@chakra-ui/react";
import { CustomText, CustomTitle } from "./pieceBanner.style";
import { type PieceBannerProps } from "./pieceBanner.type";

export const PieceBanner = ({ imgUrl, title }: PieceBannerProps) => {
    const { isMobile } = MEDIA();
    const pensionName = usePensionNameValue();
    return (
        <Center
            w="100%"
            h={isMobile ? "480px" : "640px"}
            background={`url(${imgUrl}) no-repeat center/cover`}
            flexDir="column"
            rowGap={isMobile ? "8px" : "16px"}
        >
            <CustomTitle>
                {pensionName.eng} {title.main}
            </CustomTitle>
            <CustomText>
                {pensionName.kor} {title.sub}
            </CustomText>
        </Center>
    );
};
